import React, { useState, useEffect } from 'react';
import './style/ClientCardManagementPage.css';
import NavBarAdmin from "./NavBarAdmin";
import config from './config/config';
import { useNavigate } from "react-router-dom";

const SESSION_TIMEOUT = 10 * 60 * 1000; // 5 минут

const apiGetAll = `${config.apiUrl1}/api/client-cards/get-all-card`;
const apiCreate = `${config.apiUrl1}/api/client-cards/create-card`;
const apiUpdate = `${config.apiUrl1}/api/client-cards/update-card`;

function ClientCardManagementPage() {
    const initialForm = {
        from: '',
        to: '',
        userId: '',
        isActive: false,
    };

    const [cards, setCards] = useState([]);
    const [formData, setFormData] = useState(initialForm);
    const [editId, setEditId] = useState(null);
    const navigate = useNavigate();

    // Проверка сессии администратора
    useEffect(() => {
        const isAuth = localStorage.getItem('adminAuth');
        const loginTime = localStorage.getItem('loginTime');

        if (isAuth && loginTime) {
            const diff = Date.now() - Number(loginTime);
            if (diff > SESSION_TIMEOUT) {
                // Сессия истекла
                localStorage.removeItem('adminAuth');
                localStorage.removeItem('loginTime');
                alert('Сессия истекла, пожалуйста, войдите заново.');
                navigate('/'); // возвращаем на логин
            }
        } else {
            navigate('/'); // если нет авторизации — на логин
        }
    }, [navigate]);

    // загрузка всех карт при открытии страницы
    useEffect(() => {
        fetchCards();
    }, []);

    const fetchCards = async () => {
        try {
            const res = await fetch(apiGetAll);
            if (!res.ok) throw new Error("Ошибка при получении карт");
            const data = await res.json();
            setCards(data);
        } catch (err) {
            console.error('Ошибка получения данных:', err);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleEdit = (card) => {
        setEditId(card.id);
        setFormData({
            userId: card.userId || '',
            from: '',
            to: '',
            isActive: card.isActive || false,
        });
    };

    const handleCancel = () => {
        setEditId(null);
        setFormData(initialForm);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            if (editId) {
                // Обновление userId
                const payload = {
                    id: editId,
                    userId: Number(formData.userId)
                };

                await fetch(apiUpdate, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload),
                });
            } else {
                // Создание диапазона карт
                const payload = {
                    from: Number(formData.from),
                    to: Number(formData.to),
                };

                await fetch(apiCreate, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(payload),
                });
            }

            // после сохранения обновляем список
            fetchCards();
            setFormData(initialForm);
            setEditId(null);
        } catch (err) {
            console.error("Ошибка сохранения карты:", err);
        }
    };

    return (
        <div className="user-mng-page">
            <header className="header">
                <NavBarAdmin/>
            </header>

            <div className="profile-container">
                <h2>{editId ? 'Редактировать карту' : 'Создать карты клиента'}</h2>
                <form onSubmit={handleSubmit} className="form-container">
                    {!editId && (
                        <>
                            <input
                                name="from"
                                type="number"
                                value={formData.from}
                                onChange={handleChange}
                                placeholder="От номера"
                                required
                            />
                            <input
                                name="to"
                                type="number"
                                value={formData.to}
                                onChange={handleChange}
                                placeholder="До номера"
                                required
                            />
                        </>
                    )}
                    {editId && (
                        <input
                            name="userId"
                            type="number"
                            value={formData.userId}
                            onChange={handleChange}
                            placeholder="User ID"
                            required
                        />
                    )}
                    <div className="button-group">
                        <button type="submit" className="order-btn">{editId ? 'Обновить' : 'Создать'}</button>
                        {editId && (
                            <button type="button" className="logout-btn" onClick={handleCancel}>Отмена</button>
                        )}
                    </div>
                </form>

                <table className="history-table">
                    <thead>
                    <tr>
                        <th>ID</th>
                        <th>UserID</th>
                        <th>Номер карты</th>
                        <th>Активна</th>
                        <th>Создана</th>
                        <th>Действия</th>
                    </tr>
                    </thead>
                    <tbody>
                    {cards.map(card => (
                        <tr key={card.id}>
                            <td>{card.id}</td>
                            <td>{card.userId}</td>
                            <td>{card.cardNumber}</td>
                            <td>{card.isActive ? 'Да' : 'Нет'}</td>
                            <td>{new Date(card.createdAt).toLocaleString()}</td>
                            <td>
                                <button onClick={() => handleEdit(card)} title="Редактировать">✏️</button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ClientCardManagementPage;
